import { apiClient } from '@/http/apiClient';
import { buildQuery } from '@/http/url';
const rootPath = 'bopStatuses';

class BopStatusService {
    
    public async getAllStatuses(lang:string): Promise<any> {
        return apiClient.get(`${rootPath}${buildQuery({lang})}`);
    }

}

export default new BopStatusService();